require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./clojure.set.js");

require("./cljs.spec.alpha.js");

require("./clojure.string.js");

require("./com.fulcrologic.guardrails.core.js");

require("./com.wsscode.misc.coll.js");

require("./com.wsscode.misc.refs.js");

require("./com.wsscode.pathom3.attribute.js");

require("./com.wsscode.pathom3.connect.operation.protocols.js");

require("./com.wsscode.pathom3.format.eql.js");

require("./com.wsscode.pathom3.format.shape_descriptor.js");

require("./edn_query_language.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.pathom3.connect.operation.js");
goog.provide('com.wsscode.pathom3.connect.operation');

com.wsscode.pathom3.connect.operation.operation_QMARK_ = function com$wsscode$pathom3$connect$operation$operation_QMARK_(x) {
  if (!(x == null)) {
    if (false || cljs.core.PROTOCOL_SENTINEL === x.com$wsscode$pathom3$connect$operation$protocols$IOperation$) {
      return true;
    } else {
      if (!x.cljs$lang$protocol_mask$partition$) {
        return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IOperation, x);
      } else {
        return false;
      }
    }
  } else {
    return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IOperation, x);
  }
};

com.wsscode.pathom3.connect.operation.resolver_QMARK_ = function com$wsscode$pathom3$connect$operation$resolver_QMARK_(x) {
  if (!(x == null)) {
    if (false || cljs.core.PROTOCOL_SENTINEL === x.com$wsscode$pathom3$connect$operation$protocols$IResolver$) {
      return true;
    } else {
      if (!x.cljs$lang$protocol_mask$partition$) {
        return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IResolver, x);
      } else {
        return false;
      }
    }
  } else {
    return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IResolver, x);
  }
};

com.wsscode.pathom3.connect.operation.mutation_QMARK_ = function com$wsscode$pathom3$connect$operation$mutation_QMARK_(x) {
  if (!(x == null)) {
    if (false || cljs.core.PROTOCOL_SENTINEL === x.com$wsscode$pathom3$connect$operation$protocols$IMutation$) {
      return true;
    } else {
      if (!x.cljs$lang$protocol_mask$partition$) {
        return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IMutation, x);
      } else {
        return false;
      }
    }
  } else {
    return cljs.core.native_satisfies_QMARK_(com.wsscode.pathom3.connect.operation.protocols.IMutation, x);
  }
};

cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), new cljs.core.Symbol("cljs.core", "symbol?", "cljs.core/symbol?", 1422196122, null), cljs.core.symbol_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497), new cljs.core.Symbol("cljs.core", "vector?", "cljs.core/vector?", -1550392028, null), cljs.core.vector_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703), new cljs.core.Symbol("cljs.core", "vector?", "cljs.core/vector?", -1550392028, null), cljs.core.vector_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "params", "com.wsscode.pathom3.connect.operation/params", -1389779339), new cljs.core.Symbol("cljs.core", "vector?", "cljs.core/vector?", -1550392028, null), cljs.core.vector_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "docstring", "com.wsscode.pathom3.connect.operation/docstring", -1367867441), new cljs.core.Symbol("cljs.core", "string?", "cljs.core/string?", -2072921719, null), cljs.core.string_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "cache?", "com.wsscode.pathom3.connect.operation/cache?", 575940493), new cljs.core.Symbol("cljs.core", "boolean?", "cljs.core/boolean?", 1400713761, null), cljs.core.boolean_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "cache-store", "com.wsscode.pathom3.connect.operation/cache-store", 1503197377), new cljs.core.Symbol("cljs.core", "keyword?", "cljs.core/keyword?", 713156450, null), cljs.core.keyword_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "cache-key", "com.wsscode.pathom3.connect.operation/cache-key", 1646000466), new cljs.core.Symbol("cljs.core", "fn?", "cljs.core/fn?", 71876239, null), cljs.core.fn_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "batch?", "com.wsscode.pathom3.connect.operation/batch?", 1500979317), new cljs.core.Symbol("cljs.core", "boolean?", "cljs.core/boolean?", 1400713761, null), cljs.core.boolean_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "batch-chunk-size", "com.wsscode.pathom3.connect.operation/batch-chunk-size", -1412106301), new cljs.core.Symbol("cljs.core", "pos-int?", "cljs.core/pos-int?", -2115888030, null), cljs.core.pos_int_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "priority", "com.wsscode.pathom3.connect.operation/priority", -813904543), new cljs.core.Symbol("cljs.core", "int?", "cljs.core/int?", 50730120, null), cljs.core.int_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "resolve", "com.wsscode.pathom3.connect.operation/resolve", 606027628), new cljs.core.Symbol("cljs.core", "fn?", "cljs.core/fn?", 71876239, null), cljs.core.fn_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "mutate", "com.wsscode.pathom3.connect.operation/mutate", -822588464), new cljs.core.Symbol("cljs.core", "fn?", "cljs.core/fn?", 71876239, null), cljs.core.fn_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type", "com.wsscode.pathom3.connect.operation/operation-type", 704998960), new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-mutation", "com.wsscode.pathom3.connect.operation/operation-type-mutation", -494456636), "null", new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-resolver", "com.wsscode.pathom3.connect.operation/operation-type-resolver", -1680641911), "null"], null), null), new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-mutation", "com.wsscode.pathom3.connect.operation/operation-type-mutation", -494456636), null, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-resolver", "com.wsscode.pathom3.connect.operation/operation-type-resolver", -1680641911), null], null), null));
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-config", "com.wsscode.pathom3.connect.operation/operation-config", 583946173), new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), cljs.core.map_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation", "com.wsscode.pathom3.connect.operation/operation", 874578684), new cljs.core.Symbol("com.wsscode.pathom3.connect.operation", "operation?", "com.wsscode.pathom3.connect.operation/operation?", 1767294343, null), com.wsscode.pathom3.connect.operation.operation_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "resolver", "com.wsscode.pathom3.connect.operation/resolver", 380611107), new cljs.core.Symbol("com.wsscode.pathom3.connect.operation", "resolver?", "com.wsscode.pathom3.connect.operation/resolver?", -370083233, null), com.wsscode.pathom3.connect.operation.resolver_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "mutation", "com.wsscode.pathom3.connect.operation/mutation", 2085009056), new cljs.core.Symbol("com.wsscode.pathom3.connect.operation", "mutation?", "com.wsscode.pathom3.connect.operation/mutation?", 1025315137, null), com.wsscode.pathom3.connect.operation.mutation_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "provides", "com.wsscode.pathom3.connect.operation/provides", 541419618), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433));
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "requires", "com.wsscode.pathom3.connect.operation/requires", 926175715), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433));
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optionals", "com.wsscode.pathom3.connect.operation/optionals", 1880951663), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433), new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "shape-descriptor", "com.wsscode.pathom3.format.shape-descriptor/shape-descriptor", 1733631433));
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "dynamic-name", "com.wsscode.pathom3.connect.operation/dynamic-name", 1218566238), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049));
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "dynamic-resolver?", "com.wsscode.pathom3.connect.operation/dynamic-resolver?", 868139406), new cljs.core.Symbol("cljs.core", "boolean?", "cljs.core/boolean?", 1400713761, null), cljs.core.boolean_QMARK_);
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "transform", "com.wsscode.pathom3.connect.operation/transform", -704383498), new cljs.core.Symbol("cljs.core", "fn?", "cljs.core/fn?", 71876239, null), cljs.core.fn_QMARK_);
/**
* @constructor
 * @implements {cljs.core.IRecord}
 * @implements {cljs.core.IKVReduce}
 * @implements {cljs.core.IEquiv}
 * @implements {cljs.core.IHash}
 * @implements {cljs.core.IFn}
 * @implements {cljs.core.ICollection}
 * @implements {com.wsscode.pathom3.connect.operation.protocols.IOperation}
 * @implements {cljs.core.ICounted}
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IMeta}
 * @implements {cljs.core.ICloneable}
 * @implements {cljs.core.IPrintWithWriter}
 * @implements {cljs.core.IIterable}
 * @implements {cljs.core.IWithMeta}
 * @implements {com.wsscode.pathom3.connect.operation.protocols.IResolver}
 * @implements {cljs.core.IAssociative}
 * @implements {cljs.core.IMap}
 * @implements {cljs.core.ILookup}
*/

com.wsscode.pathom3.connect.operation.Resolver = function (config, resolve, __meta, __extmap, __hash) {
  this.config = config;
  this.resolve = resolve;
  this.__meta = __meta;
  this.__extmap = __extmap;
  this.__hash = __hash;
  this.cljs$lang$protocol_mask$partition0$ = 2230716171;
  this.cljs$lang$protocol_mask$partition1$ = 139264;
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ILookup$_lookup$arity$2 = function (this__4380__auto__, k__4381__auto__) {
  var self__ = this;
  var this__4380__auto____$1 = this;
  return this__4380__auto____$1.cljs$core$ILookup$_lookup$arity$3(null, k__4381__auto__, null);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ILookup$_lookup$arity$3 = function (this__4382__auto__, k34627, else__4383__auto__) {
  var self__ = this;
  var this__4382__auto____$1 = this;
  var G__34632 = k34627;
  var G__34632__$1 = G__34632 instanceof cljs.core.Keyword ? G__34632.fqn : null;

  switch (G__34632__$1) {
    case "config":
      return self__.config;
      break;

    case "resolve":
      return self__.resolve;
      break;

    default:
      return cljs.core.get.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k34627, else__4383__auto__);
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IKVReduce$_kv_reduce$arity$3 = function (this__4399__auto__, f__4400__auto__, init__4401__auto__) {
  var self__ = this;
  var this__4399__auto____$1 = this;
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret__4402__auto__, p__34633) {
    var vec__34634 = p__34633;
    var k__4403__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34634, 0, null);
    var v__4404__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34634, 1, null);
    return f__4400__auto__.cljs$core$IFn$_invoke$arity$3 ? f__4400__auto__.cljs$core$IFn$_invoke$arity$3(ret__4402__auto__, k__4403__auto__, v__4404__auto__) : f__4400__auto__.call(null, ret__4402__auto__, k__4403__auto__, v__4404__auto__);
  }, init__4401__auto__, this__4399__auto____$1);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (this__4394__auto__, writer__4395__auto__, opts__4396__auto__) {
  var self__ = this;
  var this__4394__auto____$1 = this;

  var pr_pair__4397__auto__ = function pr_pair__4397__auto__(keyval__4398__auto__) {
    return cljs.core.pr_sequential_writer(writer__4395__auto__, cljs.core.pr_writer, "", " ", "", opts__4396__auto__, keyval__4398__auto__);
  };

  return cljs.core.pr_sequential_writer(writer__4395__auto__, pr_pair__4397__auto__, "#com.wsscode.pathom3.connect.operation.Resolver{", ", ", "}", opts__4396__auto__, cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "config", "config", 994861415), self__.config], null), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), self__.resolve], null)], null), self__.__extmap));
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IIterable$_iterator$arity$1 = function (G__34626) {
  var self__ = this;
  var G__34626__$1 = this;
  return new cljs.core.RecordIter(0, G__34626__$1, 2, new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "config", "config", 994861415), new cljs.core.Keyword(null, "resolve", "resolve", -1584445482)], null), cljs.core.truth_(self__.__extmap) ? cljs.core._iterator(self__.__extmap) : cljs.core.nil_iter());
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.com$wsscode$pathom3$connect$operation$protocols$IResolver$ = cljs.core.PROTOCOL_SENTINEL;

com.wsscode.pathom3.connect.operation.Resolver.prototype.com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$arity$3 = function (_, env, input) {
  var self__ = this;

  var ___$1 = this;

  return self__.resolve.cljs$core$IFn$_invoke$arity$2 ? self__.resolve.cljs$core$IFn$_invoke$arity$2(env, input) : self__.resolve.call(null, env, input);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IMeta$_meta$arity$1 = function (this__4378__auto__) {
  var self__ = this;
  var this__4378__auto____$1 = this;
  return self__.__meta;
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ICloneable$_clone$arity$1 = function (this__4375__auto__) {
  var self__ = this;
  var this__4375__auto____$1 = this;
  return new com.wsscode.pathom3.connect.operation.Resolver(self__.config, self__.resolve, self__.__meta, self__.__extmap, self__.__hash);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ICounted$_count$arity$1 = function (this__4384__auto__) {
  var self__ = this;
  var this__4384__auto____$1 = this;
  return 2 + cljs.core.count(self__.__extmap);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IHash$_hash$arity$1 = function (this__4376__auto__) {
  var self__ = this;
  var this__4376__auto____$1 = this;
  var h__4238__auto__ = self__.__hash;

  if (!(h__4238__auto__ == null)) {
    return h__4238__auto__;
  } else {
    var h__4238__auto____$1 = function (coll__4377__auto__) {
      return 276776581 ^ cljs.core.hash_unordered_coll(coll__4377__auto__);
    }(this__4376__auto____$1);

    self__.__hash = h__4238__auto____$1;
    return h__4238__auto____$1;
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IEquiv$_equiv$arity$2 = function (this34628, other34629) {
  var self__ = this;
  var this34628__$1 = this;
  return !(other34629 == null) && this34628__$1.constructor === other34629.constructor && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34628__$1.config, other34629.config) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34628__$1.resolve, other34629.resolve) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34628__$1.__extmap, other34629.__extmap);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IMap$_dissoc$arity$2 = function (this__4389__auto__, k__4390__auto__) {
  var self__ = this;
  var this__4389__auto____$1 = this;

  if (cljs.core.contains_QMARK_(new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "config", "config", 994861415), null, new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), null], null), null), k__4390__auto__)) {
    return cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(cljs.core._with_meta(cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, this__4389__auto____$1), self__.__meta), k__4390__auto__);
  } else {
    return new com.wsscode.pathom3.connect.operation.Resolver(self__.config, self__.resolve, self__.__meta, cljs.core.not_empty(cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(self__.__extmap, k__4390__auto__)), null);
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$ = cljs.core.PROTOCOL_SENTINEL;

com.wsscode.pathom3.connect.operation.Resolver.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$arity$1 = function (_) {
  var self__ = this;

  var ___$1 = this;

  return self__.config;
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$arity$1 = function (_) {
  var self__ = this;

  var ___$1 = this;

  return new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-resolver", "com.wsscode.pathom3.connect.operation/operation-type-resolver", -1680641911);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IAssociative$_assoc$arity$3 = function (this__4387__auto__, k__4388__auto__, G__34626) {
  var self__ = this;
  var this__4387__auto____$1 = this;
  var pred__34637 = cljs.core.keyword_identical_QMARK_;
  var expr__34638 = k__4388__auto__;

  if (cljs.core.truth_(pred__34637.cljs$core$IFn$_invoke$arity$2 ? pred__34637.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "config", "config", 994861415), expr__34638) : pred__34637.call(null, new cljs.core.Keyword(null, "config", "config", 994861415), expr__34638))) {
    return new com.wsscode.pathom3.connect.operation.Resolver(G__34626, self__.resolve, self__.__meta, self__.__extmap, null);
  } else {
    if (cljs.core.truth_(pred__34637.cljs$core$IFn$_invoke$arity$2 ? pred__34637.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), expr__34638) : pred__34637.call(null, new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), expr__34638))) {
      return new com.wsscode.pathom3.connect.operation.Resolver(self__.config, G__34626, self__.__meta, self__.__extmap, null);
    } else {
      return new com.wsscode.pathom3.connect.operation.Resolver(self__.config, self__.resolve, self__.__meta, cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k__4388__auto__, G__34626), null);
    }
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ISeqable$_seq$arity$1 = function (this__4392__auto__) {
  var self__ = this;
  var this__4392__auto____$1 = this;
  return cljs.core.seq(cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.MapEntry(new cljs.core.Keyword(null, "config", "config", 994861415), self__.config, null), new cljs.core.MapEntry(new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), self__.resolve, null)], null), self__.__extmap));
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IWithMeta$_with_meta$arity$2 = function (this__4379__auto__, G__34626) {
  var self__ = this;
  var this__4379__auto____$1 = this;
  return new com.wsscode.pathom3.connect.operation.Resolver(self__.config, self__.resolve, G__34626, self__.__extmap, self__.__hash);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$ICollection$_conj$arity$2 = function (this__4385__auto__, entry__4386__auto__) {
  var self__ = this;
  var this__4385__auto____$1 = this;

  if (cljs.core.vector_QMARK_(entry__4386__auto__)) {
    return this__4385__auto____$1.cljs$core$IAssociative$_assoc$arity$3(null, cljs.core._nth(entry__4386__auto__, 0), cljs.core._nth(entry__4386__auto__, 1));
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core._conj, this__4385__auto____$1, entry__4386__auto__);
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.call = function (unused__11636__auto__) {
  var self__ = this;
  var self__ = this;
  var G__34640 = arguments.length - 1;

  switch (G__34640) {
    case 0:
      return self__.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return self__.cljs$core$IFn$_invoke$arity$1(arguments[1]);
      break;

    case 2:
      return self__.cljs$core$IFn$_invoke$arity$2(arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length - 1)].join(''));
  }
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.apply = function (self__, args34631) {
  var self__ = this;
  var self____$1 = this;
  return self____$1.call.apply(self____$1, [self____$1].concat(cljs.core.aclone(args34631)));
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IFn$_invoke$arity$0 = function () {
  var self__ = this;

  var _this = this;

  var G__34641 = cljs.core.PersistentArrayMap.EMPTY;
  var G__34642 = cljs.core.PersistentArrayMap.EMPTY;
  return self__.resolve.cljs$core$IFn$_invoke$arity$2 ? self__.resolve.cljs$core$IFn$_invoke$arity$2(G__34641, G__34642) : self__.resolve.call(null, G__34641, G__34642);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IFn$_invoke$arity$1 = function (input) {
  var self__ = this;

  var _this = this;

  var G__34643 = cljs.core.PersistentArrayMap.EMPTY;
  var G__34644 = input;
  return self__.resolve.cljs$core$IFn$_invoke$arity$2 ? self__.resolve.cljs$core$IFn$_invoke$arity$2(G__34643, G__34644) : self__.resolve.call(null, G__34643, G__34644);
};

com.wsscode.pathom3.connect.operation.Resolver.prototype.cljs$core$IFn$_invoke$arity$2 = function (env, input) {
  var self__ = this;

  var _this = this;

  return self__.resolve.cljs$core$IFn$_invoke$arity$2 ? self__.resolve.cljs$core$IFn$_invoke$arity$2(env, input) : self__.resolve.call(null, env, input);
};

com.wsscode.pathom3.connect.operation.Resolver.getBasis = function () {
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "config", "config", -1659574354, null), new cljs.core.Symbol(null, "resolve", "resolve", 56086045, null)], null);
};

com.wsscode.pathom3.connect.operation.Resolver.cljs$lang$type = true;

com.wsscode.pathom3.connect.operation.Resolver.cljs$lang$ctorPrSeq = function (this__4423__auto__) {
  return new cljs.core.List(null, "com.wsscode.pathom3.connect.operation/Resolver", null, 1, null);
};

com.wsscode.pathom3.connect.operation.Resolver.cljs$lang$ctorPrWriter = function (this__4423__auto__, writer__4424__auto__) {
  return cljs.core._write(writer__4424__auto__, "com.wsscode.pathom3.connect.operation/Resolver");
};
/**
 * Positional factory function for com.wsscode.pathom3.connect.operation/Resolver.
 */


com.wsscode.pathom3.connect.operation.__GT_Resolver = function com$wsscode$pathom3$connect$operation$__GT_Resolver(config, resolve) {
  return new com.wsscode.pathom3.connect.operation.Resolver(config, resolve, null, null, null);
};
/**
 * Factory function for com.wsscode.pathom3.connect.operation/Resolver, taking a map of keywords to field values.
 */


com.wsscode.pathom3.connect.operation.map__GT_Resolver = function com$wsscode$pathom3$connect$operation$map__GT_Resolver(G__34630) {
  var extmap__4419__auto__ = function () {
    var G__34645 = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(G__34630, new cljs.core.Keyword(null, "config", "config", 994861415), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "resolve", "resolve", -1584445482)], 0));

    if (cljs.core.record_QMARK_(G__34630)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, G__34645);
    } else {
      return G__34645;
    }
  }();

  return new com.wsscode.pathom3.connect.operation.Resolver(new cljs.core.Keyword(null, "config", "config", 994861415).cljs$core$IFn$_invoke$arity$1(G__34630), new cljs.core.Keyword(null, "resolve", "resolve", -1584445482).cljs$core$IFn$_invoke$arity$1(G__34630), null, cljs.core.not_empty(extmap__4419__auto__), null);
};
/**
* @constructor
 * @implements {cljs.core.IRecord}
 * @implements {com.wsscode.pathom3.connect.operation.protocols.IMutation}
 * @implements {cljs.core.IKVReduce}
 * @implements {cljs.core.IEquiv}
 * @implements {cljs.core.IHash}
 * @implements {cljs.core.IFn}
 * @implements {cljs.core.ICollection}
 * @implements {com.wsscode.pathom3.connect.operation.protocols.IOperation}
 * @implements {cljs.core.ICounted}
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IMeta}
 * @implements {cljs.core.ICloneable}
 * @implements {cljs.core.IPrintWithWriter}
 * @implements {cljs.core.IIterable}
 * @implements {cljs.core.IWithMeta}
 * @implements {cljs.core.IAssociative}
 * @implements {cljs.core.IMap}
 * @implements {cljs.core.ILookup}
*/


com.wsscode.pathom3.connect.operation.Mutation = function (config, mutate, __meta, __extmap, __hash) {
  this.config = config;
  this.mutate = mutate;
  this.__meta = __meta;
  this.__extmap = __extmap;
  this.__hash = __hash;
  this.cljs$lang$protocol_mask$partition0$ = 2230716171;
  this.cljs$lang$protocol_mask$partition1$ = 139264;
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ILookup$_lookup$arity$2 = function (this__4380__auto__, k__4381__auto__) {
  var self__ = this;
  var this__4380__auto____$1 = this;
  return this__4380__auto____$1.cljs$core$ILookup$_lookup$arity$3(null, k__4381__auto__, null);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ILookup$_lookup$arity$3 = function (this__4382__auto__, k34647, else__4383__auto__) {
  var self__ = this;
  var this__4382__auto____$1 = this;
  var G__34652 = k34647;
  var G__34652__$1 = G__34652 instanceof cljs.core.Keyword ? G__34652.fqn : null;

  switch (G__34652__$1) {
    case "config":
      return self__.config;
      break;

    case "mutate":
      return self__.mutate;
      break;

    default:
      return cljs.core.get.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k34647, else__4383__auto__);
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IKVReduce$_kv_reduce$arity$3 = function (this__4399__auto__, f__4400__auto__, init__4401__auto__) {
  var self__ = this;
  var this__4399__auto____$1 = this;
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret__4402__auto__, p__34653) {
    var vec__34654 = p__34653;
    var k__4403__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34654, 0, null);
    var v__4404__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34654, 1, null);
    return f__4400__auto__.cljs$core$IFn$_invoke$arity$3 ? f__4400__auto__.cljs$core$IFn$_invoke$arity$3(ret__4402__auto__, k__4403__auto__, v__4404__auto__) : f__4400__auto__.call(null, ret__4402__auto__, k__4403__auto__, v__4404__auto__);
  }, init__4401__auto__, this__4399__auto____$1);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (this__4394__auto__, writer__4395__auto__, opts__4396__auto__) {
  var self__ = this;
  var this__4394__auto____$1 = this;

  var pr_pair__4397__auto__ = function pr_pair__4397__auto__(keyval__4398__auto__) {
    return cljs.core.pr_sequential_writer(writer__4395__auto__, cljs.core.pr_writer, "", " ", "", opts__4396__auto__, keyval__4398__auto__);
  };

  return cljs.core.pr_sequential_writer(writer__4395__auto__, pr_pair__4397__auto__, "#com.wsscode.pathom3.connect.operation.Mutation{", ", ", "}", opts__4396__auto__, cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "config", "config", 994861415), self__.config], null), new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), self__.mutate], null)], null), self__.__extmap));
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IIterable$_iterator$arity$1 = function (G__34646) {
  var self__ = this;
  var G__34646__$1 = this;
  return new cljs.core.RecordIter(0, G__34646__$1, 2, new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "config", "config", 994861415), new cljs.core.Keyword(null, "mutate", "mutate", 1422419038)], null), cljs.core.truth_(self__.__extmap) ? cljs.core._iterator(self__.__extmap) : cljs.core.nil_iter());
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IMeta$_meta$arity$1 = function (this__4378__auto__) {
  var self__ = this;
  var this__4378__auto____$1 = this;
  return self__.__meta;
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ICloneable$_clone$arity$1 = function (this__4375__auto__) {
  var self__ = this;
  var this__4375__auto____$1 = this;
  return new com.wsscode.pathom3.connect.operation.Mutation(self__.config, self__.mutate, self__.__meta, self__.__extmap, self__.__hash);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ICounted$_count$arity$1 = function (this__4384__auto__) {
  var self__ = this;
  var this__4384__auto____$1 = this;
  return 2 + cljs.core.count(self__.__extmap);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.com$wsscode$pathom3$connect$operation$protocols$IMutation$ = cljs.core.PROTOCOL_SENTINEL;

com.wsscode.pathom3.connect.operation.Mutation.prototype.com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$arity$3 = function (_, env, input) {
  var self__ = this;

  var ___$1 = this;

  return self__.mutate.cljs$core$IFn$_invoke$arity$2 ? self__.mutate.cljs$core$IFn$_invoke$arity$2(env, input) : self__.mutate.call(null, env, input);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IHash$_hash$arity$1 = function (this__4376__auto__) {
  var self__ = this;
  var this__4376__auto____$1 = this;
  var h__4238__auto__ = self__.__hash;

  if (!(h__4238__auto__ == null)) {
    return h__4238__auto__;
  } else {
    var h__4238__auto____$1 = function (coll__4377__auto__) {
      return -1635502555 ^ cljs.core.hash_unordered_coll(coll__4377__auto__);
    }(this__4376__auto____$1);

    self__.__hash = h__4238__auto____$1;
    return h__4238__auto____$1;
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IEquiv$_equiv$arity$2 = function (this34648, other34649) {
  var self__ = this;
  var this34648__$1 = this;
  return !(other34649 == null) && this34648__$1.constructor === other34649.constructor && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34648__$1.config, other34649.config) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34648__$1.mutate, other34649.mutate) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this34648__$1.__extmap, other34649.__extmap);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IMap$_dissoc$arity$2 = function (this__4389__auto__, k__4390__auto__) {
  var self__ = this;
  var this__4389__auto____$1 = this;

  if (cljs.core.contains_QMARK_(new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "config", "config", 994861415), null, new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), null], null), null), k__4390__auto__)) {
    return cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(cljs.core._with_meta(cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, this__4389__auto____$1), self__.__meta), k__4390__auto__);
  } else {
    return new com.wsscode.pathom3.connect.operation.Mutation(self__.config, self__.mutate, self__.__meta, cljs.core.not_empty(cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(self__.__extmap, k__4390__auto__)), null);
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$ = cljs.core.PROTOCOL_SENTINEL;

com.wsscode.pathom3.connect.operation.Mutation.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$arity$1 = function (_) {
  var self__ = this;

  var ___$1 = this;

  return self__.config;
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$arity$1 = function (_) {
  var self__ = this;

  var ___$1 = this;

  return new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "operation-type-mutation", "com.wsscode.pathom3.connect.operation/operation-type-mutation", -494456636);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IAssociative$_assoc$arity$3 = function (this__4387__auto__, k__4388__auto__, G__34646) {
  var self__ = this;
  var this__4387__auto____$1 = this;
  var pred__34657 = cljs.core.keyword_identical_QMARK_;
  var expr__34658 = k__4388__auto__;

  if (cljs.core.truth_(pred__34657.cljs$core$IFn$_invoke$arity$2 ? pred__34657.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "config", "config", 994861415), expr__34658) : pred__34657.call(null, new cljs.core.Keyword(null, "config", "config", 994861415), expr__34658))) {
    return new com.wsscode.pathom3.connect.operation.Mutation(G__34646, self__.mutate, self__.__meta, self__.__extmap, null);
  } else {
    if (cljs.core.truth_(pred__34657.cljs$core$IFn$_invoke$arity$2 ? pred__34657.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), expr__34658) : pred__34657.call(null, new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), expr__34658))) {
      return new com.wsscode.pathom3.connect.operation.Mutation(self__.config, G__34646, self__.__meta, self__.__extmap, null);
    } else {
      return new com.wsscode.pathom3.connect.operation.Mutation(self__.config, self__.mutate, self__.__meta, cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k__4388__auto__, G__34646), null);
    }
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ISeqable$_seq$arity$1 = function (this__4392__auto__) {
  var self__ = this;
  var this__4392__auto____$1 = this;
  return cljs.core.seq(cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.MapEntry(new cljs.core.Keyword(null, "config", "config", 994861415), self__.config, null), new cljs.core.MapEntry(new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), self__.mutate, null)], null), self__.__extmap));
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IWithMeta$_with_meta$arity$2 = function (this__4379__auto__, G__34646) {
  var self__ = this;
  var this__4379__auto____$1 = this;
  return new com.wsscode.pathom3.connect.operation.Mutation(self__.config, self__.mutate, G__34646, self__.__extmap, self__.__hash);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$ICollection$_conj$arity$2 = function (this__4385__auto__, entry__4386__auto__) {
  var self__ = this;
  var this__4385__auto____$1 = this;

  if (cljs.core.vector_QMARK_(entry__4386__auto__)) {
    return this__4385__auto____$1.cljs$core$IAssociative$_assoc$arity$3(null, cljs.core._nth(entry__4386__auto__, 0), cljs.core._nth(entry__4386__auto__, 1));
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core._conj, this__4385__auto____$1, entry__4386__auto__);
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.call = function (unused__11636__auto__) {
  var self__ = this;
  var self__ = this;
  var G__34660 = arguments.length - 1;

  switch (G__34660) {
    case 0:
      return self__.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return self__.cljs$core$IFn$_invoke$arity$1(arguments[1]);
      break;

    case 2:
      return self__.cljs$core$IFn$_invoke$arity$2(arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length - 1)].join(''));
  }
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.apply = function (self__, args34651) {
  var self__ = this;
  var self____$1 = this;
  return self____$1.call.apply(self____$1, [self____$1].concat(cljs.core.aclone(args34651)));
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IFn$_invoke$arity$0 = function () {
  var self__ = this;

  var _this = this;

  var G__34661 = cljs.core.PersistentArrayMap.EMPTY;
  var G__34662 = cljs.core.PersistentArrayMap.EMPTY;
  return self__.mutate.cljs$core$IFn$_invoke$arity$2 ? self__.mutate.cljs$core$IFn$_invoke$arity$2(G__34661, G__34662) : self__.mutate.call(null, G__34661, G__34662);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IFn$_invoke$arity$1 = function (input) {
  var self__ = this;

  var _this = this;

  var G__34663 = cljs.core.PersistentArrayMap.EMPTY;
  var G__34664 = input;
  return self__.mutate.cljs$core$IFn$_invoke$arity$2 ? self__.mutate.cljs$core$IFn$_invoke$arity$2(G__34663, G__34664) : self__.mutate.call(null, G__34663, G__34664);
};

com.wsscode.pathom3.connect.operation.Mutation.prototype.cljs$core$IFn$_invoke$arity$2 = function (env, input) {
  var self__ = this;

  var _this = this;

  return self__.mutate.cljs$core$IFn$_invoke$arity$2 ? self__.mutate.cljs$core$IFn$_invoke$arity$2(env, input) : self__.mutate.call(null, env, input);
};

com.wsscode.pathom3.connect.operation.Mutation.getBasis = function () {
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "config", "config", -1659574354, null), new cljs.core.Symbol(null, "mutate", "mutate", -1232016731, null)], null);
};

com.wsscode.pathom3.connect.operation.Mutation.cljs$lang$type = true;

com.wsscode.pathom3.connect.operation.Mutation.cljs$lang$ctorPrSeq = function (this__4423__auto__) {
  return new cljs.core.List(null, "com.wsscode.pathom3.connect.operation/Mutation", null, 1, null);
};

com.wsscode.pathom3.connect.operation.Mutation.cljs$lang$ctorPrWriter = function (this__4423__auto__, writer__4424__auto__) {
  return cljs.core._write(writer__4424__auto__, "com.wsscode.pathom3.connect.operation/Mutation");
};
/**
 * Positional factory function for com.wsscode.pathom3.connect.operation/Mutation.
 */


com.wsscode.pathom3.connect.operation.__GT_Mutation = function com$wsscode$pathom3$connect$operation$__GT_Mutation(config, mutate) {
  return new com.wsscode.pathom3.connect.operation.Mutation(config, mutate, null, null, null);
};
/**
 * Factory function for com.wsscode.pathom3.connect.operation/Mutation, taking a map of keywords to field values.
 */


com.wsscode.pathom3.connect.operation.map__GT_Mutation = function com$wsscode$pathom3$connect$operation$map__GT_Mutation(G__34650) {
  var extmap__4419__auto__ = function () {
    var G__34665 = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(G__34650, new cljs.core.Keyword(null, "config", "config", 994861415), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "mutate", "mutate", 1422419038)], 0));

    if (cljs.core.record_QMARK_(G__34650)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, G__34665);
    } else {
      return G__34665;
    }
  }();

  return new com.wsscode.pathom3.connect.operation.Mutation(new cljs.core.Keyword(null, "config", "config", 994861415).cljs$core$IFn$_invoke$arity$1(G__34650), new cljs.core.Keyword(null, "mutate", "mutate", 1422419038).cljs$core$IFn$_invoke$arity$1(G__34650), null, cljs.core.not_empty(extmap__4419__auto__), null);
};
/**
 * Make an attribute optional
 */


com.wsscode.pathom3.connect.operation._QMARK_ = function com$wsscode$pathom3$connect$operation$_QMARK_(attr) {
  return edn_query_language.core.update_property_param.cljs$core$IFn$_invoke$arity$variadic(attr, cljs.core.assoc, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optional?", "com.wsscode.pathom3.connect.operation/optional?", -926143517), true], 0));
};

com.wsscode.pathom3.connect.operation.operation_config = function com$wsscode$pathom3$connect$operation$operation_config(operation) {
  return com.wsscode.pathom3.connect.operation.protocols._operation_config(operation);
};

com.wsscode.pathom3.connect.operation.operation_type = function com$wsscode$pathom3$connect$operation$operation_type(operation) {
  return com.wsscode.pathom3.connect.operation.protocols._operation_type(operation);
};

com.wsscode.pathom3.connect.operation.describe_input_STAR_ = function com$wsscode$pathom3$connect$operation$describe_input_STAR_(ast, path, outs_STAR_, opt_parent_QMARK_) {
  var seq__34666 = cljs.core.seq(new cljs.core.Keyword(null, "children", "children", -940561982).cljs$core$IFn$_invoke$arity$1(ast));
  var chunk__34667 = null;
  var count__34668 = 0;
  var i__34669 = 0;

  while (true) {
    if (i__34669 < count__34668) {
      var map__34684 = chunk__34667.cljs$core$IIndexed$_nth$arity$2(null, i__34669);
      var map__34684__$1 = (!(map__34684 == null) ? map__34684.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34684.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34684) : map__34684;
      var node = map__34684__$1;
      var key = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34684__$1, new cljs.core.Keyword(null, "key", "key", -1516042587));
      var params = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34684__$1, new cljs.core.Keyword(null, "params", "params", 710516235));

      var entry_34776 = function () {
        var G__34686 = cljs.core.PersistentArrayMap.EMPTY;

        if (cljs.core.seq(params)) {
          return cljs.core.with_meta(G__34686, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "params", "com.wsscode.pathom3.format.shape-descriptor/params", -1116912186), params], null));
        } else {
          return G__34686;
        }
      }();

      var opt_QMARK__34777 = function () {
        var or__4126__auto__ = opt_parent_QMARK_;

        if (cljs.core.truth_(or__4126__auto__)) {
          return or__4126__auto__;
        } else {
          return new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optional?", "com.wsscode.pathom3.connect.operation/optional?", -926143517).cljs$core$IFn$_invoke$arity$1(params);
        }
      }();

      if (cljs.core.truth_(opt_QMARK__34777)) {
        cljs.core._vreset_BANG_(outs_STAR_, cljs.core.assoc_in(cljs.core._deref(outs_STAR_), cljs.core.concat.cljs$core$IFn$_invoke$arity$variadic(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optionals", "com.wsscode.pathom3.connect.operation/optionals", 1880951663)], null), path, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [key], null)], 0)), entry_34776));
      } else {
        cljs.core._vreset_BANG_(outs_STAR_, cljs.core.assoc_in(cljs.core._deref(outs_STAR_), cljs.core.concat.cljs$core$IFn$_invoke$arity$variadic(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "requires", "com.wsscode.pathom3.connect.operation/requires", 926175715)], null), path, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [key], null)], 0)), entry_34776));
      }

      var G__34687_34778 = node;
      var G__34688_34779 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(path, key);
      var G__34689_34780 = outs_STAR_;
      var G__34690_34781 = opt_QMARK__34777;
      com.wsscode.pathom3.connect.operation.describe_input_STAR_.cljs$core$IFn$_invoke$arity$4 ? com.wsscode.pathom3.connect.operation.describe_input_STAR_.cljs$core$IFn$_invoke$arity$4(G__34687_34778, G__34688_34779, G__34689_34780, G__34690_34781) : com.wsscode.pathom3.connect.operation.describe_input_STAR_.call(null, G__34687_34778, G__34688_34779, G__34689_34780, G__34690_34781);
      var G__34782 = seq__34666;
      var G__34783 = chunk__34667;
      var G__34784 = count__34668;
      var G__34785 = i__34669 + 1;
      seq__34666 = G__34782;
      chunk__34667 = G__34783;
      count__34668 = G__34784;
      i__34669 = G__34785;
      continue;
    } else {
      var temp__5804__auto__ = cljs.core.seq(seq__34666);

      if (temp__5804__auto__) {
        var seq__34666__$1 = temp__5804__auto__;

        if (cljs.core.chunked_seq_QMARK_(seq__34666__$1)) {
          var c__4556__auto__ = cljs.core.chunk_first(seq__34666__$1);
          var G__34786 = cljs.core.chunk_rest(seq__34666__$1);
          var G__34787 = c__4556__auto__;
          var G__34788 = cljs.core.count(c__4556__auto__);
          var G__34789 = 0;
          seq__34666 = G__34786;
          chunk__34667 = G__34787;
          count__34668 = G__34788;
          i__34669 = G__34789;
          continue;
        } else {
          var map__34691 = cljs.core.first(seq__34666__$1);
          var map__34691__$1 = (!(map__34691 == null) ? map__34691.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34691.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34691) : map__34691;
          var node = map__34691__$1;
          var key = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34691__$1, new cljs.core.Keyword(null, "key", "key", -1516042587));
          var params = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34691__$1, new cljs.core.Keyword(null, "params", "params", 710516235));

          var entry_34790 = function () {
            var G__34693 = cljs.core.PersistentArrayMap.EMPTY;

            if (cljs.core.seq(params)) {
              return cljs.core.with_meta(G__34693, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.format.shape-descriptor", "params", "com.wsscode.pathom3.format.shape-descriptor/params", -1116912186), params], null));
            } else {
              return G__34693;
            }
          }();

          var opt_QMARK__34791 = function () {
            var or__4126__auto__ = opt_parent_QMARK_;

            if (cljs.core.truth_(or__4126__auto__)) {
              return or__4126__auto__;
            } else {
              return new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optional?", "com.wsscode.pathom3.connect.operation/optional?", -926143517).cljs$core$IFn$_invoke$arity$1(params);
            }
          }();

          if (cljs.core.truth_(opt_QMARK__34791)) {
            cljs.core._vreset_BANG_(outs_STAR_, cljs.core.assoc_in(cljs.core._deref(outs_STAR_), cljs.core.concat.cljs$core$IFn$_invoke$arity$variadic(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "optionals", "com.wsscode.pathom3.connect.operation/optionals", 1880951663)], null), path, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [key], null)], 0)), entry_34790));
          } else {
            cljs.core._vreset_BANG_(outs_STAR_, cljs.core.assoc_in(cljs.core._deref(outs_STAR_), cljs.core.concat.cljs$core$IFn$_invoke$arity$variadic(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "requires", "com.wsscode.pathom3.connect.operation/requires", 926175715)], null), path, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [key], null)], 0)), entry_34790));
          }

          var G__34694_34793 = node;
          var G__34695_34794 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(path, key);
          var G__34696_34795 = outs_STAR_;
          var G__34697_34796 = opt_QMARK__34791;
          com.wsscode.pathom3.connect.operation.describe_input_STAR_.cljs$core$IFn$_invoke$arity$4 ? com.wsscode.pathom3.connect.operation.describe_input_STAR_.cljs$core$IFn$_invoke$arity$4(G__34694_34793, G__34695_34794, G__34696_34795, G__34697_34796) : com.wsscode.pathom3.connect.operation.describe_input_STAR_.call(null, G__34694_34793, G__34695_34794, G__34696_34795, G__34697_34796);
          var G__34797 = cljs.core.next(seq__34666__$1);
          var G__34798 = null;
          var G__34799 = 0;
          var G__34800 = 0;
          seq__34666 = G__34797;
          chunk__34667 = G__34798;
          count__34668 = G__34799;
          i__34669 = G__34800;
          continue;
        }
      } else {
        return null;
      }
    }

    break;
  }
};

com.wsscode.pathom3.connect.operation.describe_input = function com$wsscode$pathom3$connect$operation$describe_input(input) {
  var input_ast = edn_query_language.core.query__GT_ast(input);
  var outs_STAR_ = cljs.core.volatile_BANG_(new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "requires", "com.wsscode.pathom3.connect.operation/requires", 926175715), cljs.core.PersistentArrayMap.EMPTY], null));
  com.wsscode.pathom3.connect.operation.describe_input_STAR_(input_ast, cljs.core.PersistentVector.EMPTY, outs_STAR_, false);
  return cljs.core.deref(outs_STAR_);
};

com.wsscode.pathom3.connect.operation.eql__GT_root_attrs = function com$wsscode$pathom3$connect$operation$eql__GT_root_attrs(eql) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentHashSet.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(new cljs.core.Keyword(null, "key", "key", -1516042587)), new cljs.core.Keyword(null, "children", "children", -940561982).cljs$core$IFn$_invoke$arity$1(edn_query_language.core.query__GT_ast(eql)));
};

com.wsscode.pathom3.connect.operation.input_destructure_missing = function com$wsscode$pathom3$connect$operation$input_destructure_missing(p__34698) {
  var map__34699 = p__34698;
  var map__34699__$1 = (!(map__34699 == null) ? map__34699.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34699.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34699) : map__34699;
  var input = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34699__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497));
  var inferred_input = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34699__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "inferred-input", "com.wsscode.pathom3.connect.operation/inferred-input", -1192133345));

  if (cljs.core.truth_(function () {
    var and__4115__auto__ = input;

    if (cljs.core.truth_(and__4115__auto__)) {
      return inferred_input;
    } else {
      return and__4115__auto__;
    }
  }())) {
    var missing = clojure.set.difference.cljs$core$IFn$_invoke$arity$2(com.wsscode.pathom3.connect.operation.eql__GT_root_attrs(inferred_input), com.wsscode.pathom3.connect.operation.eql__GT_root_attrs(input));

    if (cljs.core.seq(missing)) {
      return missing;
    } else {
      return null;
    }
  } else {
    return null;
  }
};
/**
 * Helper to create a resolver. A resolver have at least a name, the output definition
 *   and the resolve function.
 * 
 *   You can create a resolver using a map:
 * 
 *    (resolver
 *      {::op-name 'foo
 *       ::output  [:foo]
 *       ::resolve (fn [env input] ...)})
 * 
 *   Or with the helper syntax:
 * 
 *    (resolver 'foo {::output [:foo]} (fn [env input] ...))
 * 
 *   Returns an instance of the Resolver type.
 *   
 */


com.wsscode.pathom3.connect.operation.resolver = function com$wsscode$pathom3$connect$operation$resolver(var_args) {
  var G__34702 = arguments.length;

  switch (G__34702) {
    case 2:
      return com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 1:
      return com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$2 = function (op_name, config) {
  return com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$1(com.wsscode.misc.coll.merge_defaults(config, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), op_name], null)));
};

com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$3 = function (op_name, config, resolve) {
  return com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$1(cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(com.wsscode.misc.coll.merge_defaults(config, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), op_name], null)), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "resolve", "com.wsscode.pathom3.connect.operation/resolve", 606027628), resolve));
};

com.wsscode.pathom3.connect.operation.resolver.cljs$core$IFn$_invoke$arity$1 = function (p__34703) {
  var map__34704 = p__34703;
  var map__34704__$1 = (!(map__34704 == null) ? map__34704.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34704.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34704) : map__34704;
  var config = map__34704__$1;
  var transform = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34704__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "transform", "com.wsscode.pathom3.connect.operation/transform", -704383498));
  var op_name = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34704__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049));
  var inferred_input = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34704__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "inferred-input", "com.wsscode.pathom3.connect.operation/inferred-input", -1192133345));
  var input = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34704__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497));
  var config__$1 = com.wsscode.pathom3.connect.operation.resolver_QMARK_(config) ? config : function () {
    var G__34706 = config;

    if (cljs.core.truth_(transform)) {
      return transform.cljs$core$IFn$_invoke$arity$1 ? transform.cljs$core$IFn$_invoke$arity$1(G__34706) : transform.call(null, G__34706);
    } else {
      return G__34706;
    }
  }();

  if (cljs.spec.alpha.valid_QMARK_.cljs$core$IFn$_invoke$arity$2(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34707) {
    return cljs.core.map_QMARK_(G__34707);
  }], null), function (G__34707) {
    return cljs.core.map_QMARK_(G__34707);
  }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config__$1)) {} else {
    cljs.spec.alpha.explain(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34708) {
      return cljs.core.map_QMARK_(G__34708);
    }], null), function (G__34708) {
      return cljs.core.map_QMARK_(G__34708);
    }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config__$1);
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2(["Invalid config on resolver ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.core.name)].join(''), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "explain-data", "explain-data", -1124944340), cljs.spec.alpha.explain_data(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34709) {
      return cljs.core.map_QMARK_(G__34709);
    }], null), function (G__34709) {
      return cljs.core.map_QMARK_(G__34709);
    }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config__$1)], null));
  }

  if (cljs.core.not(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "disable-validate-input-destructuring?", "com.wsscode.pathom3.connect.operation/disable-validate-input-destructuring?", -1487302369).cljs$core$IFn$_invoke$arity$1(config__$1))) {
    var temp__5802__auto___34806 = com.wsscode.pathom3.connect.operation.input_destructure_missing(config__$1);

    if (cljs.core.truth_(temp__5802__auto___34806)) {
      var missing_34807 = temp__5802__auto___34806;
      throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2(["Input of resolver ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(op_name), " destructuring requires attributes \"", clojure.string.join.cljs$core$IFn$_invoke$arity$2(",", missing_34807), "\" that are not present at the input definition."].join(''), new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497), input, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "inferred-input", "com.wsscode.pathom3.connect.operation/inferred-input", -1192133345), inferred_input], null));
    } else {}
  } else {}

  if (com.wsscode.pathom3.connect.operation.resolver_QMARK_(config__$1)) {
    return config__$1;
  } else {
    var map__34710 = config__$1;
    var map__34710__$1 = (!(map__34710 == null) ? map__34710.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34710.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34710) : map__34710;
    var resolve = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34710__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "resolve", "com.wsscode.pathom3.connect.operation/resolve", 606027628));
    var output = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34710__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703));
    var defaults = cljs.core.truth_(output) ? new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497), cljs.core.PersistentVector.EMPTY, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "provides", "com.wsscode.pathom3.connect.operation/provides", 541419618), com.wsscode.pathom3.format.shape_descriptor.query__GT_shape_descriptor(output)], null) : cljs.core.PersistentArrayMap.EMPTY;
    var map__34711 = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([defaults, config__$1], 0)), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "resolve", "com.wsscode.pathom3.connect.operation/resolve", 606027628), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "transform", "com.wsscode.pathom3.connect.operation/transform", -704383498)], 0));
    var map__34711__$1 = (!(map__34711 == null) ? map__34711.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34711.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34711) : map__34711;
    var config_SINGLEQUOTE_ = map__34711__$1;
    var input__$1 = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34711__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497));

    var config_SINGLEQUOTE___$1 = function () {
      var G__34714 = config_SINGLEQUOTE_;

      if (cljs.core.truth_(input__$1)) {
        return cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([G__34714, com.wsscode.pathom3.connect.operation.describe_input(input__$1)], 0));
      } else {
        return G__34714;
      }
    }();

    return com.wsscode.pathom3.connect.operation.__GT_Resolver(config_SINGLEQUOTE___$1, function () {
      var or__4126__auto__ = resolve;

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return function (_, ___$1) {
          return null;
        };
      }
    }());
  }
};

com.wsscode.pathom3.connect.operation.resolver.cljs$lang$maxFixedArity = 3;
/**
 * Helper to create a mutation. A mutation must have a name and the mutate function.
 * 
 *   You can create a mutation using a map:
 * 
 *    (mutation
 *      {::op-name 'foo
 *       ::output  [:foo]
 *       ::mutate  (fn [env params] ...)})
 * 
 *   Or with the helper syntax:
 * 
 *    (mutation 'foo {} (fn [env params] ...))
 * 
 *   Returns an instance of the Mutation type.
 *   
 */

com.wsscode.pathom3.connect.operation.mutation = function com$wsscode$pathom3$connect$operation$mutation(var_args) {
  var G__34716 = arguments.length;

  switch (G__34716) {
    case 2:
      return com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 1:
      return com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$2 = function (op_name, config) {
  return com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$1(com.wsscode.misc.coll.merge_defaults(config, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), op_name], null)));
};

com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$3 = function (op_name, config, mutate) {
  return com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$1(cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(com.wsscode.misc.coll.merge_defaults(config, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "op-name", "com.wsscode.pathom3.connect.operation/op-name", -1249801049), op_name], null)), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "mutate", "com.wsscode.pathom3.connect.operation/mutate", -822588464), mutate));
};

com.wsscode.pathom3.connect.operation.mutation.cljs$core$IFn$_invoke$arity$1 = function (p__34717) {
  var map__34718 = p__34717;
  var map__34718__$1 = (!(map__34718 == null) ? map__34718.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34718.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34718) : map__34718;
  var config = map__34718__$1;
  var transform = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34718__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "transform", "com.wsscode.pathom3.connect.operation/transform", -704383498));

  if (cljs.spec.alpha.valid_QMARK_.cljs$core$IFn$_invoke$arity$2(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34720) {
    return cljs.core.map_QMARK_(G__34720);
  }], null), function (G__34720) {
    return cljs.core.map_QMARK_(G__34720);
  }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config)) {} else {
    cljs.spec.alpha.explain(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34721) {
      return cljs.core.map_QMARK_(G__34721);
    }], null), function (G__34721) {
      return cljs.core.map_QMARK_(G__34721);
    }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config);
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2(["Invalid config on mutation ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.core.name)].join(''), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "explain-data", "explain-data", -1124944340), cljs.spec.alpha.explain_data(cljs.spec.alpha.map_spec_impl(cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "req-un", "req-un", 1074571008), new cljs.core.Keyword(null, "opt-un", "opt-un", 883442496), new cljs.core.Keyword(null, "gfn", "gfn", 791517474), new cljs.core.Keyword(null, "pred-exprs", "pred-exprs", 1792271395), new cljs.core.Keyword(null, "keys-pred", "keys-pred", 858984739), new cljs.core.Keyword(null, "opt-keys", "opt-keys", 1262688261), new cljs.core.Keyword(null, "req-specs", "req-specs", 553962313), new cljs.core.Keyword(null, "req", "req", -326448303), new cljs.core.Keyword(null, "req-keys", "req-keys", 514319221), new cljs.core.Keyword(null, "opt-specs", "opt-specs", -384905450), new cljs.core.Keyword(null, "pred-forms", "pred-forms", 172611832), new cljs.core.Keyword(null, "opt", "opt", -794706369)], [null, null, null, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [function (G__34722) {
      return cljs.core.map_QMARK_(G__34722);
    }], null), function (G__34722) {
      return cljs.core.map_QMARK_(G__34722);
    }, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, null, cljs.core.PersistentVector.EMPTY, cljs.core.PersistentVector.EMPTY, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [cljs.core.list(new cljs.core.Symbol("cljs.core", "fn", "cljs.core/fn", -1065745098, null), new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "%", "%", -950237169, null)], null), cljs.core.list(new cljs.core.Symbol("cljs.core", "map?", "cljs.core/map?", -1390345523, null), new cljs.core.Symbol(null, "%", "%", -950237169, null)))], null), null])), config)], null));
  }

  if (com.wsscode.pathom3.connect.operation.mutation_QMARK_(config)) {
    return config;
  } else {
    var map__34723 = function () {
      var G__34724 = config;

      if (cljs.core.truth_(transform)) {
        return transform.cljs$core$IFn$_invoke$arity$1 ? transform.cljs$core$IFn$_invoke$arity$1(G__34724) : transform.call(null, G__34724);
      } else {
        return G__34724;
      }
    }();

    var map__34723__$1 = (!(map__34723 == null) ? map__34723.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34723.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34723) : map__34723;
    var config__$1 = map__34723__$1;
    var mutate = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34723__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "mutate", "com.wsscode.pathom3.connect.operation/mutate", -822588464));
    var output = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34723__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703));
    var defaults = cljs.core.truth_(output) ? new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "provides", "com.wsscode.pathom3.connect.operation/provides", 541419618), com.wsscode.pathom3.format.shape_descriptor.query__GT_shape_descriptor(output)], null) : cljs.core.PersistentArrayMap.EMPTY;
    var config_SINGLEQUOTE_ = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([defaults, config__$1], 0)), new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "mutate", "com.wsscode.pathom3.connect.operation/mutate", -822588464), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "transform", "com.wsscode.pathom3.connect.operation/transform", -704383498)], 0));
    return com.wsscode.pathom3.connect.operation.__GT_Mutation(config_SINGLEQUOTE_, function () {
      var or__4126__auto__ = mutate;

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return function (_, ___$1) {
          return null;
        };
      }
    }());
  }
};

com.wsscode.pathom3.connect.operation.mutation.cljs$lang$maxFixedArity = 3;
/**
 * Pull parameters from environment. Always returns a map.
 */

com.wsscode.pathom3.connect.operation.params = function com$wsscode$pathom3$connect$operation$params(env) {
  var or__4126__auto__ = cljs.core.get_in.cljs$core$IFn$_invoke$arity$2(env, new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "node", "com.wsscode.pathom3.connect.planner/node", 325156565), new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "params", "com.wsscode.pathom3.connect.planner/params", 1545394210)], null));

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    return cljs.core.PersistentArrayMap.EMPTY;
  }
};
/**
 * Set current node params to params.
 */


com.wsscode.pathom3.connect.operation.with_node_params = function com$wsscode$pathom3$connect$operation$with_node_params(var_args) {
  var G__34727 = arguments.length;

  switch (G__34727) {
    case 1:
      return com.wsscode.pathom3.connect.operation.with_node_params.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return com.wsscode.pathom3.connect.operation.with_node_params.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

com.wsscode.pathom3.connect.operation.with_node_params.cljs$core$IFn$_invoke$arity$1 = function (params) {
  return new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "node", "com.wsscode.pathom3.connect.planner/node", 325156565), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "params", "com.wsscode.pathom3.connect.planner/params", 1545394210), params], null)], null);
};

com.wsscode.pathom3.connect.operation.with_node_params.cljs$core$IFn$_invoke$arity$2 = function (env, params) {
  return cljs.core.assoc_in(env, new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "node", "com.wsscode.pathom3.connect.planner/node", 325156565), new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "params", "com.wsscode.pathom3.connect.planner/params", 1545394210)], null), params);
};

com.wsscode.pathom3.connect.operation.with_node_params.cljs$lang$maxFixedArity = 2;
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "defresolver-args", "com.wsscode.pathom3.connect.operation/defresolver-args", 1313253759), new cljs.core.Symbol("cljs.core", "any?", "cljs.core/any?", -2068111842, null), cljs.core.any_QMARK_);

com.wsscode.pathom3.connect.operation.as_entry_QMARK_ = function com$wsscode$pathom3$connect$operation$as_entry_QMARK_(x) {
  return com.wsscode.misc.refs.kw_identical_QMARK_(new cljs.core.Keyword(null, "as", "as", 1148689641), cljs.core.first(x));
};

com.wsscode.pathom3.connect.operation.extract_destructure_map_keys_as_keywords = function com$wsscode$pathom3$connect$operation$extract_destructure_map_keys_as_keywords(m) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentVector.EMPTY, cljs.core.comp.cljs$core$IFn$_invoke$arity$2(cljs.core.remove.cljs$core$IFn$_invoke$arity$1(com.wsscode.pathom3.connect.operation.as_entry_QMARK_), cljs.core.mapcat.cljs$core$IFn$_invoke$arity$1(function (p__34730) {
    var vec__34731 = p__34730;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34731, 0, null);
    var val = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34731, 1, null);

    if (k instanceof cljs.core.Keyword && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2("keys", cljs.core.name(k))) {
      return cljs.core.map.cljs$core$IFn$_invoke$arity$2(function (p1__34729_SHARP_) {
        return cljs.core.keyword.cljs$core$IFn$_invoke$arity$2(function () {
          var or__4126__auto__ = cljs.core.namespace(p1__34729_SHARP_);

          if (cljs.core.truth_(or__4126__auto__)) {
            return or__4126__auto__;
          } else {
            return cljs.core.namespace(k);
          }
        }(), cljs.core.name(p1__34729_SHARP_));
      }, val);
    } else {
      return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [val], null);
    }
  })), m);
};

com.wsscode.pathom3.connect.operation.params__GT_resolver_options = function com$wsscode$pathom3$connect$operation$params__GT_resolver_options(p__34734) {
  var map__34735 = p__34734;
  var map__34735__$1 = (!(map__34735 == null) ? map__34735.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34735.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34735) : map__34735;
  var arglist = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34735__$1, new cljs.core.Keyword(null, "arglist", "arglist", -1808272150));
  var options = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34735__$1, new cljs.core.Keyword(null, "options", "options", 99638489));
  var body = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34735__$1, new cljs.core.Keyword(null, "body", "body", -2049205669));
  var docstring = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34735__$1, new cljs.core.Keyword(null, "docstring", "docstring", 879233117));
  var vec__34737 = cljs.core.last(arglist);
  var input_type = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34737, 0, null);
  var input_arg = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34737, 1, null);
  var last_expr = cljs.core.last(body);
  var inferred_input = com.wsscode.misc.refs.kw_identical_QMARK_(new cljs.core.Keyword(null, "map", "map", 1371690461), input_type) ? com.wsscode.pathom3.connect.operation.extract_destructure_map_keys_as_keywords(input_arg) : null;
  var G__34740 = options;
  var G__34740__$1 = cljs.core.map_QMARK_(last_expr) && cljs.core.not(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703).cljs$core$IFn$_invoke$arity$1(options)) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34740, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703), com.wsscode.pathom3.format.eql.data__GT_query(last_expr)) : G__34740;
  var G__34740__$2 = cljs.core.truth_(inferred_input) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34740__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "inferred-input", "com.wsscode.pathom3.connect.operation/inferred-input", -1192133345), inferred_input) : G__34740__$1;
  var G__34740__$3 = cljs.core.truth_(function () {
    var and__4115__auto__ = inferred_input;

    if (cljs.core.truth_(and__4115__auto__)) {
      return cljs.core.not(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497).cljs$core$IFn$_invoke$arity$1(options));
    } else {
      return and__4115__auto__;
    }
  }()) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34740__$2, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "input", "com.wsscode.pathom3.connect.operation/input", -1553849497), inferred_input) : G__34740__$2;

  if (cljs.core.truth_(docstring)) {
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34740__$3, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "docstring", "com.wsscode.pathom3.connect.operation/docstring", -1367867441), docstring);
  } else {
    return G__34740__$3;
  }
};

com.wsscode.pathom3.connect.operation.params__GT_mutation_options = function com$wsscode$pathom3$connect$operation$params__GT_mutation_options(p__34741) {
  var map__34742 = p__34741;
  var map__34742__$1 = (!(map__34742 == null) ? map__34742.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34742.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34742) : map__34742;
  var arglist = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34742__$1, new cljs.core.Keyword(null, "arglist", "arglist", -1808272150));
  var options = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34742__$1, new cljs.core.Keyword(null, "options", "options", 99638489));
  var body = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34742__$1, new cljs.core.Keyword(null, "body", "body", -2049205669));
  var docstring = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34742__$1, new cljs.core.Keyword(null, "docstring", "docstring", 879233117));
  var vec__34744 = cljs.core.last(arglist);
  var input_type = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34744, 0, null);
  var params_arg = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__34744, 1, null);
  var last_expr = cljs.core.last(body);
  var G__34747 = options;
  var G__34747__$1 = cljs.core.map_QMARK_(last_expr) && cljs.core.not(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703).cljs$core$IFn$_invoke$arity$1(options)) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34747, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "output", "com.wsscode.pathom3.connect.operation/output", 801488703), com.wsscode.pathom3.format.eql.data__GT_query(last_expr)) : G__34747;
  var G__34747__$2 = com.wsscode.misc.refs.kw_identical_QMARK_(new cljs.core.Keyword(null, "map", "map", 1371690461), input_type) && cljs.core.not(new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "params", "com.wsscode.pathom3.connect.operation/params", -1389779339).cljs$core$IFn$_invoke$arity$1(options)) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34747__$1, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "params", "com.wsscode.pathom3.connect.operation/params", -1389779339), com.wsscode.pathom3.connect.operation.extract_destructure_map_keys_as_keywords(params_arg)) : G__34747__$1;

  if (cljs.core.truth_(docstring)) {
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(G__34747__$2, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "docstring", "com.wsscode.pathom3.connect.operation/docstring", -1367867441), docstring);
  } else {
    return G__34747__$2;
  }
};
/**
 * Ensures arglist contains two elements.
 */


com.wsscode.pathom3.connect.operation.normalize_arglist = function com$wsscode$pathom3$connect$operation$normalize_arglist(arglist) {
  var arglist__$1 = arglist;

  while (true) {
    if (cljs.core.count(arglist__$1) < 2) {
      var G__34816 = cljs.core.into.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "sym", "sym", -1444860305), new cljs.core.Symbol(null, "_", "_", -1201019570, null)], null)], null), arglist__$1);
      arglist__$1 = G__34816;
      continue;
    } else {
      return arglist__$1;
    }

    break;
  }
};
/**
 * Returns a new resolver with the modified config. You can use this to change anything
 *   in the resolver configuration map. The only thing you can't change from here is the
 *   resolver or mutation functions. You can use the wrap-resolve and wrap-mutation
 *   helpers to do that.
 */


com.wsscode.pathom3.connect.operation.update_config = function com$wsscode$pathom3$connect$operation$update_config(var_args) {
  var G__34761 = arguments.length;

  switch (G__34761) {
    case 2:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    case 5:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    case 6:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$6(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      break;

    case 7:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$7(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
      break;

    case 8:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$8(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7]);
      break;

    case 9:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$9(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
      break;

    case 10:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$10(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
      break;

    case 11:
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$11(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___34818 = arguments.length;
      var i__4737__auto___34819 = 0;

      while (true) {
        if (i__4737__auto___34819 < len__4736__auto___34818) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___34819]);
          var G__34826 = i__4737__auto___34819 + 1;
          i__4737__auto___34819 = G__34826;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(11), 0, null);
      return com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], argseq__4758__auto__);
  }
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$2 = function (operation, f) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$3(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f);
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$3 = function (operation, f, a1) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$4(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1);
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$4 = function (operation, f, a1, a2) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$5(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2);
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$5 = function (operation, f, a1, a2, a3) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$6(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3);
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$6 = function (operation, f, a1, a2, a3, a4) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$7 = function (operation, f, a1, a2, a3, a4, a5) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4, a5], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$8 = function (operation, f, a1, a2, a3, a4, a5, a6) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4, a5, a6], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$9 = function (operation, f, a1, a2, a3, a4, a5, a6, a7) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4, a5, a6, a7], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$10 = function (operation, f, a1, a2, a3, a4, a5, a6, a7, a8) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4, a5, a6, a7, a8], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$11 = function (operation, f, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$variadic(operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, a2, a3, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a4, a5, a6, a7, a8, a9], 0));
};

com.wsscode.pathom3.connect.operation.update_config.cljs$core$IFn$_invoke$arity$variadic = function (operation, f, a1, a2, a3, a4, a5, a6, a7, a8, a9, args) {
  return cljs.core.apply.cljs$core$IFn$_invoke$arity$variadic(cljs.core.update, operation, new cljs.core.Keyword(null, "config", "config", 994861415), f, a1, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([a2, a3, a4, a5, a6, a7, a8, a9, args], 0));
};
/** @this {Function} */


com.wsscode.pathom3.connect.operation.update_config.cljs$lang$applyTo = function (seq34749) {
  var G__34750 = cljs.core.first(seq34749);
  var seq34749__$1 = cljs.core.next(seq34749);
  var G__34751 = cljs.core.first(seq34749__$1);
  var seq34749__$2 = cljs.core.next(seq34749__$1);
  var G__34752 = cljs.core.first(seq34749__$2);
  var seq34749__$3 = cljs.core.next(seq34749__$2);
  var G__34753 = cljs.core.first(seq34749__$3);
  var seq34749__$4 = cljs.core.next(seq34749__$3);
  var G__34754 = cljs.core.first(seq34749__$4);
  var seq34749__$5 = cljs.core.next(seq34749__$4);
  var G__34755 = cljs.core.first(seq34749__$5);
  var seq34749__$6 = cljs.core.next(seq34749__$5);
  var G__34756 = cljs.core.first(seq34749__$6);
  var seq34749__$7 = cljs.core.next(seq34749__$6);
  var G__34757 = cljs.core.first(seq34749__$7);
  var seq34749__$8 = cljs.core.next(seq34749__$7);
  var G__34758 = cljs.core.first(seq34749__$8);
  var seq34749__$9 = cljs.core.next(seq34749__$8);
  var G__34759 = cljs.core.first(seq34749__$9);
  var seq34749__$10 = cljs.core.next(seq34749__$9);
  var G__34760 = cljs.core.first(seq34749__$10);
  var seq34749__$11 = cljs.core.next(seq34749__$10);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__34750, G__34751, G__34752, G__34753, G__34754, G__34755, G__34756, G__34757, G__34758, G__34759, G__34760, seq34749__$11);
};

com.wsscode.pathom3.connect.operation.update_config.cljs$lang$maxFixedArity = 11;
/**
 * Return a new resolver with the resolve fn modified. You can use the previous fn or
 *   just replace. Here is a noop wrapper example:
 * 
 *   (wrap-resolve resolver
 *  (fn [resolve]
 *    (fn [env input]
 *      (resolve env input)))
 */

com.wsscode.pathom3.connect.operation.wrap_resolve = function com$wsscode$pathom3$connect$operation$wrap_resolve(resolver, f) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$3(resolver, new cljs.core.Keyword(null, "resolve", "resolve", -1584445482), f);
};
/**
 * Return a new mutation with the resolve fn modified. You can use the previous fn or
 *   just replace. Here is a noop wrapper example:
 * 
 *   (wrap-mutate mutation
 *  (fn [mutate]
 *    (fn [env params]
 *      (mutate env params)))
 */


com.wsscode.pathom3.connect.operation.wrap_mutate = function com$wsscode$pathom3$connect$operation$wrap_mutate(mutation, f) {
  return cljs.core.update.cljs$core$IFn$_invoke$arity$3(mutation, new cljs.core.Keyword(null, "mutate", "mutate", 1422419038), f);
};
/**
 * Makes a value final. This will add some meta-data to a collection or a map to
 *   flag it as final. Data marked as final will make Pathom skip sub-processing it.
 * 
 *   Example:
 * 
 *    (pco/defresolver complex-done-list []
 *      {:dont-process (pco/final-value [{:a 1} {:a 2} ...])})
 * 
 *   Note that in this case, a query like `[{:dont-process [:a :b]}]` won't even try
 *   to process `:b`, the vector value will be returned as-is.
 */


com.wsscode.pathom3.connect.operation.final_value = function com$wsscode$pathom3$connect$operation$final_value(x) {
  return cljs.core.vary_meta.cljs$core$IFn$_invoke$arity$4(x, cljs.core.assoc, new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "final", "com.wsscode.pathom3.connect.operation/final", -910956993), true);
};

com.wsscode.pathom3.connect.operation.final_value_QMARK_ = function com$wsscode$pathom3$connect$operation$final_value_QMARK_(x) {
  var G__34762 = x;
  var G__34762__$1 = G__34762 == null ? null : cljs.core.meta(G__34762);
  var G__34762__$2 = G__34762__$1 == null ? null : new cljs.core.Keyword("com.wsscode.pathom3.connect.operation", "final", "com.wsscode.pathom3.connect.operation/final", -910956993).cljs$core$IFn$_invoke$arity$1(G__34762__$1);

  if (G__34762__$2 == null) {
    return null;
  } else {
    return G__34762__$2 === true;
  }
};

Object.defineProperty(module.exports, "as_entry_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.as_entry_QMARK_;
  }
});
Object.defineProperty(module.exports, "Resolver", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.Resolver;
  }
});
Object.defineProperty(module.exports, "operation_type", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.operation_type;
  }
});
Object.defineProperty(module.exports, "describe_input", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.describe_input;
  }
});
Object.defineProperty(module.exports, "describe_input_STAR_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.describe_input_STAR_;
  }
});
Object.defineProperty(module.exports, "params__GT_resolver_options", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.params__GT_resolver_options;
  }
});
Object.defineProperty(module.exports, "input_destructure_missing", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.input_destructure_missing;
  }
});
Object.defineProperty(module.exports, "eql__GT_root_attrs", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.eql__GT_root_attrs;
  }
});
Object.defineProperty(module.exports, "extract_destructure_map_keys_as_keywords", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.extract_destructure_map_keys_as_keywords;
  }
});
Object.defineProperty(module.exports, "map__GT_Resolver", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.map__GT_Resolver;
  }
});
Object.defineProperty(module.exports, "wrap_resolve", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.wrap_resolve;
  }
});
Object.defineProperty(module.exports, "Mutation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.Mutation;
  }
});
Object.defineProperty(module.exports, "final_value", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.final_value;
  }
});
Object.defineProperty(module.exports, "resolver_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.resolver_QMARK_;
  }
});
Object.defineProperty(module.exports, "final_value_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.final_value_QMARK_;
  }
});
Object.defineProperty(module.exports, "normalize_arglist", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.normalize_arglist;
  }
});
Object.defineProperty(module.exports, "operation_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.operation_QMARK_;
  }
});
Object.defineProperty(module.exports, "params", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.params;
  }
});
Object.defineProperty(module.exports, "update_config", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.update_config;
  }
});
Object.defineProperty(module.exports, "mutation_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.mutation_QMARK_;
  }
});
Object.defineProperty(module.exports, "with_node_params", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.with_node_params;
  }
});
Object.defineProperty(module.exports, "mutation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.mutation;
  }
});
Object.defineProperty(module.exports, "_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation._QMARK_;
  }
});
Object.defineProperty(module.exports, "__GT_Resolver", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.__GT_Resolver;
  }
});
Object.defineProperty(module.exports, "operation_config", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.operation_config;
  }
});
Object.defineProperty(module.exports, "resolver", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.resolver;
  }
});
Object.defineProperty(module.exports, "__GT_Mutation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.__GT_Mutation;
  }
});
Object.defineProperty(module.exports, "map__GT_Mutation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.map__GT_Mutation;
  }
});
Object.defineProperty(module.exports, "params__GT_mutation_options", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.params__GT_mutation_options;
  }
});
Object.defineProperty(module.exports, "wrap_mutate", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.wrap_mutate;
  }
});